export interface JsonFileExporterPlugin {
  // ANDROID
  writeToFile(options: { fileName: string }): Promise<{ value: any }>;
  addFusionDataTables(options: { value: any }): Promise<{ value: any }>;
  addTableData(options: { value: any }): Promise<{ value: any }>;
  addRefTables(options: { value: any }): Promise<{ value: any }>;
  addFusionDataColumns(options: { value: any }): Promise<{ value: any }>;
  addFussionEntities(options: { value: any }): Promise<{ value: any }>;
  addUsers(options: { value: any }): Promise<{ value: any }>;
  addConfigHeaders(options: { value: any }): Promise<{ value: any }>;
  reset(options: { value: any }): Promise<{ value: any }>;
  // IOS
  exportFile(options: { value: any }): Promise<{ value: any }>;
}
